"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendTracking = sendTracking;
exports.track = track;
function sendTracking(src) {
    if (global.navigator.sendBeacon) {
        global.navigator.sendBeacon(src);
    } else {
        var img = new global.Image();
        var handler = function handler() {
            img.onload = null;
            img.onerror = null;
            img = null;
        };
        img.onload = handler;
        img.onerror = handler;
        img.src = src;
    }
}

function track() {
    var trackers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    trackers.forEach(sendTracking);
}
//# sourceMappingURL=tracking.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/tracking.js
 ** module id = 469
 ** module chunks = 1
 **/